import { useQuery } from '@tanstack/react-query';
import { apiService } from '../../../services/api';

// STD-015: server state for the Calendar tab domain. apiService is imported
// here (a *.queries.ts file) per STD-016.
//
// Planned flights are date-range-scoped — FullCalendar drives the window via
// onDatesSet; the component passes the range as query parameters. Reference
// data (serials, pilots, customers, projects) is stable lookup data shared by
// flightMetadataOptions.queries but kept local here to avoid a cross-domain
// coupling for now.

export const calendarKeys = {
  all: ['calendar'] as const,
  flights: (from: string, to: string) => [...calendarKeys.all, 'flights', from, to] as const,
  referenceData: () => [...calendarKeys.all, 'referenceData'] as const,
};

export function usePlannedFlightsQuery(from: string | null, to: string | null) {
  return useQuery({
    queryKey: calendarKeys.flights(from ?? '', to ?? ''),
    enabled: !!from && !!to,
    meta: { skipGlobalErrorToast: true },
    queryFn: () => apiService.getPlannedFlights(from!, to!),
  });
}

export function useCalendarReferenceDataQuery() {
  return useQuery({
    queryKey: calendarKeys.referenceData(),
    meta: { skipGlobalErrorToast: true },
    queryFn: async () => {
      const [serialNumbers, pilots, customers, projects] = await Promise.all([
        apiService.getSerialNumbers(),
        apiService.getPilots(),
        apiService.getCustomers(),
        apiService.getProjects(),
      ]);
      return { serialNumbers, pilots, customers, projects };
    },
  });
}
